import React from "react";

import RoleExplainer from "@/app/Views/StaticPages/HomePage/components/roleExplainer/RoleExplainer.js";

import { JobDetails, RoleExplanations } from "../utils/helpers";

interface JobDescriptionProps {
	jobDetails: JobDetails;
	roleExplanations: RoleExplanations | null;
}

export function JobDescription({ jobDetails, roleExplanations }: JobDescriptionProps) {
	return (
		<>
			{/* Role Explainer */}
			{roleExplanations && (
				<div>
					<RoleExplainer roleExplanations={roleExplanations} />
				</div>
			)}

			{/* Job Description */}
			<div>
				<h2 className="text-base font-semibold mb-2 font-inter mt-5">Job Description</h2>
				<div
					className="text-gray-700 font-inter"
					dangerouslySetInnerHTML={{
						__html: jobDetails?.jobDescription?.lookingToHire || "",
					}}
				/>
			</div>

			{/* Responsibilities */}
			<div className="mb-8">
				<h2 className="text-base font-semibold mb-2 font-inter">Responsibilities</h2>
				<ul className="list-disc text-gray-700 font-inter pl-4">
					{jobDetails?.jobDescription?.responsibilities?.map((item, index) => {
						return (
							<li key={index}>
								<div
									dangerouslySetInnerHTML={{
										__html: item.value,
									}}
								/>
							</li>
						);
					})}
				</ul>
			</div>

			{/* Requirements */}
			<div className="mb-8">
				<h2 className="text-base font-semibold mb-2 font-inter">Requirements</h2>
				<ul className="list-disc text-gray-700 font-inter pl-4">
					{jobDetails?.jobDescription?.qualifications?.map((item, index) => {
						return (
							<li key={index}>
								<div
									dangerouslySetInnerHTML={{
										__html: item.value,
									}}
								/>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
}
